import { render, staticRenderFns } from "./ActivitySpeakingMessage.vue?vue&type=template&id=70522bec&scoped=true"
import script from "./ActivitySpeakingMessage.vue?vue&type=script&lang=ts"
export * from "./ActivitySpeakingMessage.vue?vue&type=script&lang=ts"
import style0 from "./ActivitySpeakingMessage.vue?vue&type=style&index=0&id=70522bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70522bec",
  null
  
)

/* custom blocks */
import block0 from "./ActivitySpeakingMessage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports